
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chrome-devtools",
      function () {
        return require("private-next-pages/chrome-devtools.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chrome-devtools"])
      });
    }
  